import type { IServiceSuccess } from 'core/model/interfaces/service.interface';
import { https } from 'shared/utils/https';
import type {
  ICategoryDTO,
  IGetPriceGroupsResponse,
  IGetPriceListsResponse,
  IGetZonesResponse,
  IPriceGroupDTO,
  IPriceListDTO,
  IZoneDTO,
} from './master-entities.dto';

const masterEntitiesBaseURL = '/v1';

export const masterEntitiesData = {
  getPriceGroupList: async (): Promise<Array<IPriceGroupDTO>> => {
    const { data } = await https.get<IGetPriceGroupsResponse>(`${masterEntitiesBaseURL}/price-groups`);

    const { priceGroups } = data;

    return priceGroups;
  },
  getZoneList: async (): Promise<Array<IZoneDTO>> => {
    const { data } = await await https.get<IGetZonesResponse>(`${masterEntitiesBaseURL}/zones/distributors/branches`);

    const { zones } = data;

    return zones;
  },
  getPriceList: async (selectedPriceGroups?: string): Promise<Array<IPriceListDTO>> => {
    const params = selectedPriceGroups ? { priceGroupCode: selectedPriceGroups } : undefined;
    const {
      data: {
        data: { priceLists },
      },
    } = await https.get<IServiceSuccess<IGetPriceListsResponse>>(`${masterEntitiesBaseURL}/price-lists`, {
      params,
    });

    return priceLists;
  },
  getCategoryList: async (): Promise<Array<ICategoryDTO>> => {
    const { data } = await https.get<Array<ICategoryDTO>>(`${masterEntitiesBaseURL}/categories`);

    return data;
  },
};
